import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';

export default function useOrgs() {
    const authenticatedApi = useAuthenticatedApi();

    const listOrgs = async () => {
        const response = await authenticatedApi.get('/orgs');
        return response.data;
    };

    const getOrg = async (orgId: number) => {
        const response = await authenticatedApi.get(`/orgs/${orgId}`);
        return response.data;
    };

    const createOrg = async (org: any) => {
        const response = await authenticatedApi.post(
            '/orgs',
            JSON.stringify(org),
        );
        return response.data;
    };

    const updateOrg = async (
        orgId: number,
        org: { name: string; logo?: string | null },
    ) => {
        const response = await authenticatedApi.put(
            `/orgs/${orgId}`,
            JSON.stringify(org),
        );
        return response.data;
    };

    /* org-scoped by-year rollups (the global /media/stats etc. have no
       org filter and can't back an org page) */
    const getOrgStats = async (orgId: number) => {
        const response = await authenticatedApi.get(`/orgs/${orgId}/stats`);
        return response.data;
    };

    return {
        listOrgs,
        createOrg,
        getOrg,
        updateOrg,
        getOrgStats,
    };
}
